import { createFileRoute } from "@tanstack/react-router";
import { LegalDocument } from "@/features/public/Legal";

export const Route = createFileRoute("/terms")({ component: () => <LegalDocument doc="terms" /> });
